import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a table view for reversion reload.
 * @extends JetView
 */
export default class tableReversionReloadView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scroll: true, // Enable scrolling
            columns: [
                // Column definitions
                {
                    id: 'detailTittle',
                    header: '',
                    tooltip: _('Acción'), // Tooltip for action column
                    template: function (obj) {
                        // Template for action icon
                        return "<span class='webix_icon wxi-close info'></span>";
                    },
                },
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                {
                    id: 'DateTimeCreation',
                    header: _('Fecha/Hora Creación'), // Creation date column
                    width: 200,
                    sort: 'int',
                },
                { id: 'Name', header: _('Nombres'), width: 150, sort: 'int' }, // Name column
                { id: 'Email', header: _('Email'), width: 250, sort: 'int' }, // Email column
                { id: 'Phone', header: _('Teléfono'), width: 100, sort: 'int' }, // Phone column
                {
                    id: 'Message',
                    header: _('Mensaje'), // Message column
                    width: 400,
                    sort: 'int',
                },
            ],
            onClick: {
                // Event handler for clicking the info icon
                info: function (euv, id) {
                    this.$scope.app.callEvent('popupInfo:button', [[]]); // Trigger popup info event
                },
            },
            footer: false, // Disable footer
            loadahead: 0, // No preloading
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'Management/GetManagementContactUser'; // API URL
        var filter = ''; // Filter string
        var vthis = this; // Reference to the current instance

        // Event listener for filtering data
        this.on(this.app, 'managementContact:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom
                                string1 = string1 + '&dateTo=' + date; // Add dateTo
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Handle object filters
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Load data for selected player
        });

        // Popup window configuration
        var popupInfo = webix.ui({
            view: 'window',
            id: 'infoWindow', // ID for the popup window
            width: 550, // Width of the popup
            height: 450, // Height of the popup
            fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Información') }, // Label for popup header
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Modal popup
            body: {
                view: 'scrollview',
                scroll: 'xy', // Enable scrolling
                body: {
                    view: 'form',
                    id: 'infoForm', // ID for the form in the popup
                    elements: [
                        // Form elements
                        {
                            margin: 10,
                            cols: [
                                {
                                    view: 'text',
                                    labelPosition: 'top',
                                    label: _('Id'), // ID field
                                    name: 'Id',
                                    readonly: true, // Read-only field
                                    minWidth: 220,
                                },
                                {
                                    view: 'text',
                                    labelPosition: 'top',
                                    label: _('Fecha/Hora Creación'), // Creation date field
                                    name: 'DateTimeCreation',
                                    readonly: true,
                                    minWidth: 220,
                                },
                            ],
                        },
                        {
                            margin: 10,
                            cols: [
                                {
                                    view: 'text',
                                    labelPosition: 'top',
                                    label: _('Nombres'), // Name field
                                    name: 'Name',
                                    readonly: true,
                                    minWidth: 220,
                                },
                                {
                                    view: 'text',
                                    labelPosition: 'top',
                                    label: _('Email'), // Email field
                                    name: 'Email',
                                    readonly: true,
                                    minWidth: 220,
                                },
                            ],
                        },
                        {
                            margin: 10,
                            cols: [
                                {
                                    view: 'text',
                                    labelPosition: 'top',
                                    label: _('Teléfono'), // Phone field
                                    name: 'Phone',
                                    readonly: true,
                                    minWidth: 220,
                                },
                            ],
                        },
                        {
                            margin: 10,
                            cols: [
                                {
                                    view: 'textarea',
                                    labelPosition: 'top',
                                    label: _('Mensaje'), // Message field
                                    name: 'Message',
                                    readonly: true,
                                    minWidth: 220,
                                    height: 150,
                                },
                            ],
                        },
                    ],
                },
            },
        });

        // Event listener for showing popup info
        this.on(this.app, 'popupInfo:button', (filter) => {
            popupInfo.show(); // Show the popup
            $$('infoForm').bind($$('datatable')); // Bind form to datatable
        });
    }
}

// FILE DOCUMENTED
